import CustomButton from '../../../../components/customFormControls/button/Button'
import { Sizes } from '../../../../types'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PATHS } from '../../../../routes/Routes'

const SourceActions = () => {
  const navigate = useNavigate()
  const handleAddNew = () => {
    navigate(PATHS.CREATE_SOURCE)
  }
  return (
    <>
      <div className='action'>
        <CustomButton
          onClick={handleAddNew}
          size={Sizes.Medium}
          variant='secondary'
          icon='ki-plus'
          label='Add New'
        ></CustomButton>
      </div>
    </>
  )
}
export default SourceActions
